import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Button} from 'semantic-ui-react';
import {hasAccessPermission} from '../../common/permissions/validations';
import {resources, scopes} from '../../common/permissions/dictionary';
import {paths} from '../../common/dictionaries/urls';
import {Actions} from '../../common/actions';
import {
  isIntegerNumber,
  getNumberWithoutCommas,
  isNumWithMaxNDecimals,
} from '../../common/util/fieldsValidation';
import ExcelReader from '../../excelReader/components/index';
import SalesAndBudgetsTable from './table';

const nameColumns = ['DEALER RUC', 'AGENCIA', 'TIPO', 'AÑO', 'MES', 'MONTO'];

class SalesAndBudgetsLoad extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'typeOfSubmit': null,
      'refreshPage': false,
      'showData': false,
      'errors': [],
    };
    this.onClearClick = this.onClearClick.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);
    this.readExcelFile = this.readExcelFile.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.SalesAndBudgetsLoad,
        scopes.Create
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.clearSalesAndBudgetsData();
    this.props.changeSalesAndBudgetsListPage(0);
  }

  onClearClick() {
    this.props.clearSalesAndBudgetsData();
    this.setState({
      'showData': false,
      'errors': [],
    });
  }

  onSaveClick() {
    const {salesAndBudgetsList} = this.props;
    this.props.createSalesAndBudgets({'values': salesAndBudgetsList});
  }

  getParsedData(data) {
    const columnsNumbers = 10;
    const dataParsed = [];
    for (let i = 1; i < data.length; i++) {
      const rowParsed = {};
      for (let j = 0; j < columnsNumbers; j++) {
        switch (j) {
          case 0:
            rowParsed.dealerRuc = data[i][j];
            break;
          case 1:
            rowParsed.agency = data[i][j];
            break;
          case 2:
            rowParsed.type = data[i][j].toUpperCase();
            break;
          case 3:
            rowParsed.year = data[i][j];
            break;
          case 4:
            rowParsed.month = data[i][j];
            break;
          case 5:
            const price = data[i][j].replace(',', '.');
            rowParsed.amount = parseFloat(price);
            break;
          default:
            break;
        }
      }
      dataParsed.push(rowParsed);
    }
    return dataParsed;
  }

  valueIsEmpty(value) {
    return !value;
  }

  validateRequiredField(value, currentColumn) {
    return this.valueIsEmpty(value) ?
      ` Verifique el campo ${nameColumns[currentColumn]}, es requerido.` :
      '';
  }

  validateTypeField(value, currentColumn) {
    if (this.valueIsEmpty(value)) {
      return ` Verifique el campo ${nameColumns[currentColumn]}, es requerido.`;
    }
    if (!(value.toUpperCase() === 'V' || value.toUpperCase() === 'P')) {
      return ` Verifique el valor del campo ${nameColumns[currentColumn]}.`;
    }
    return '';
  }

  validateYearField(value, currentColumn) {
    if (this.valueIsEmpty(value)) {
      return ` Verifique el campo ${nameColumns[currentColumn]}, es requerido.`;
    }
    if (!isIntegerNumber(value) || value.length !== 4) {
      return ` Verifique el valor del campo ${nameColumns[currentColumn]}, posee un formato incorrecto.`;
    }
    return '';
  }

  validateMonthField(value, currentColumn) {
    if (this.valueIsEmpty(value)) {
      return ` Verifique el campo ${nameColumns[currentColumn]}, es requerido.`;
    }
    if (!isIntegerNumber(value) || value < 1 || value > 12) {
      return ` Verifique el valor del campo ${nameColumns[currentColumn]}, posee un formato incorrecto.`;
    }
    return '';
  }

  validatePriceField(value, currentColumn) {
    if (this.valueIsEmpty(value, currentColumn)) {
      return ` Verifique el campo ${nameColumns[currentColumn]}, es requerido y debe ser un valor numérico con máximo
        2 decimales mayor a 0.`;
    }
    if (value && value.includes('.')) {
      return ` Verifique el campo ${nameColumns[currentColumn]}, posee un formato incorrecto.`;
    }
    let price = value.replace(',', '.');
    price = value ? parseFloat(price) : 0;
    price = price ? getNumberWithoutCommas(price) : null;

    if (price <= 0 || !isNumWithMaxNDecimals(price, 2)) {
      return ` Verifique el campo ${nameColumns[currentColumn]}, debe ser un valor numérico con máximo 2 decimales
        mayor a 0.`;
    }
    return '';
  }

  validateColumn(value, currentColumn) {
    const columns = {
      [0]: () => this.validateRequiredField(value, currentColumn),
      [1]: () => this.validateRequiredField(value, currentColumn),
      [2]: () => this.validateTypeField(value, currentColumn),
      [3]: () => this.validateYearField(value, currentColumn),
      [4]: () => this.validateMonthField(value, currentColumn),
      [5]: () => this.validatePriceField(value, currentColumn),
    };
    return columns[currentColumn];
  }

  validateData(data) {
    const columnsNumbers = 6;
    const rowsWithErrors = [];

    for (let i = 1; i < data.length; i++) {
      let errorsByRow = '';
      for (let j = 0; j < columnsNumbers; j++) {
        const value = data[i][j];
        errorsByRow += this.validateColumn(value, j)(j);
      }
      if (errorsByRow) {
        rowsWithErrors.push({'row': i + 1, 'message': errorsByRow});
      }
    }
    return rowsWithErrors;
  }

  readExcelFile(data) {
    const rowsWithErrors = this.validateData(data);
    if (rowsWithErrors.length > 0) {
      this.setState({
        'errors': rowsWithErrors,
        'showData': true,
      });
      return;
    }

    const dataParsed = this.getParsedData(data);
    this.props.saveSalesAndBudgetsDataFromExcel(dataParsed);
    this.setState({
      'errors': [],
      'showData': true,
    });
  }

  render() {
    const {errors, showData} = this.state;
    const {saving, salesAndBudgetsByPage} = this.props;
    return (
      <div className='sales-and-budgets-create'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Ingreso de Ventas y Presupuestos</h2>
              <div className='title-bar-actions'>
                <ExcelReader
                  onGetFile={this.readExcelFile}
                  saving={saving}
                />
                <Button
                  type='button'
                  secondary
                  className='toyota-primary'
                  disabled={
                    !(errors.length || salesAndBudgetsByPage.length) || saving
                  }
                  onClick={this.onClearClick}
                >
                  Cancelar
                </Button>
                <Button
                  type='button'
                  primary
                  className='toyota-primary'
                  disabled={!salesAndBudgetsByPage.length || saving}
                  loading={saving}
                  onClick={this.onSaveClick}
                >
                  Guardar
                </Button>
              </div>
            </div>
          </div>
        </Card>
        <SalesAndBudgetsTable showData={showData} errors={errors} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'saving': state.salesAndBudgetsLoad.saving,
    'salesAndBudgetsByPage': state.salesAndBudgetsLoad.page,
    'salesAndBudgetsList': state.salesAndBudgetsLoad.list,
    'permissions': state.session.permissions,
  };
};

const {
  clearSalesAndBudgetsData,
  saveSalesAndBudgetsDataFromExcel,
  createSalesAndBudgets,
  changeSalesAndBudgetsListPage,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  clearSalesAndBudgetsData,
  saveSalesAndBudgetsDataFromExcel,
  createSalesAndBudgets,
  changeSalesAndBudgetsListPage,
  navigateTo,
})(SalesAndBudgetsLoad);
